import { VERTICAL_KEYS } from '../vertical.js';
import type { VerticalLandingContent } from './types.js';

// =============================================================================
// Imobiliário geral landing content · compra pra morar ou investir, sem
// régua MCMV. Copy no plural, pensada pra imobiliária com equipe; um corretor
// solo (ex: Angélica Coelho) sobrescreve em primeira pessoa na própria landing.
// =============================================================================

export const imobiliarioGeralLandingContent: VerticalLandingContent = {
  verticalKey: VERTICAL_KEYS.IMOBILIARIO_GERAL,

  // Verde profundo + dourado: o mesmo par da Angélica Coelho, que também é um padrão
  // comum de "imobiliária premium". Outro tenant troca via pageContent.theme.
  defaultTheme: {
    primaryColor: '#0F4A31',
    accentColor: '#C49547',
  },

  brokerSubtitle: 'Imóveis na Grande Florianópolis',
  brokerHeaderCta: 'Encontrar imóvel',
  brokerCardLabel: 'Atendimento',
  brokerCardCta: 'Encontrar meu imóvel',

  heroBadge: 'Compra, venda e investimento',
  heroHeadlineDefault: 'O imóvel certo pra você, do jeito certo',
  heroSubheadlineDefault:
    'Conte o que você procura e quanto pretende investir. Separamos as opções que fazem sentido pra você e cuidamos do financiamento e da documentação.',
  heroPrimaryCta: 'Encontrar meu imóvel',
  heroSecondaryCta: 'Como funciona',
  trustBadges: ['Atendimento personalizado', 'Ajuda com financiamento e documentação', 'Sem compromisso'],

  howItWorksTitle: 'Como funciona',
  howItWorksSubtitle: 'Três passos até o imóvel certo.',
  howItWorksSteps: [
    {
      title: 'Conte o que você procura',
      body: 'Tipo de imóvel, cidade, faixa de valor e prazo. Leva menos de 2 minutos.',
    },
    {
      title: 'Receba as opções certas',
      body: 'Separamos os imóveis que cabem no seu perfil e no seu planejamento.',
    },
    {
      title: 'Feche com segurança',
      body: 'Acompanhamos a negociação, o financiamento e a documentação até a entrega das chaves.',
    },
  ],

  aboutTitle: 'Quem vai te atender',

  listingsTitle: 'Imóveis em destaque',
  listingsSubtitle: 'Opções selecionadas na Grande Florianópolis.',

  faqTitle: 'Perguntas frequentes',
  faqSubtitle: 'Tire suas dúvidas antes de começar.',
  faqItems: [
    {
      q: 'Preciso me comprometer com alguma coisa?',
      a: 'Não. Responder o formulário e conversar com a equipe é sem compromisso. Você decide se quer seguir depois de ver as opções.',
    },
    {
      q: 'Vocês ajudam com o financiamento?',
      a: 'Sim. Ajudamos na simulação e acompanhamos a aprovação do crédito e a documentação até a assinatura.',
    },
    {
      q: 'Posso usar o FGTS na compra?',
      a: 'Pode, desde que você se enquadre nas regras do FGTS para compra de imóvel residencial. Avaliamos o seu caso no atendimento.',
    },
    {
      q: 'Trabalham com imóveis na planta e prontos?',
      a: 'Sim. Lançamentos, imóveis na planta e prontos pra morar, para morar ou investir.',
    },
    {
      q: 'Tenho um imóvel. Posso dar como parte do pagamento?',
      a: 'Depende do imóvel e da negociação com o vendedor. Conversamos sobre o seu caso no atendimento.',
    },
    {
      q: 'Como falo com a equipe?',
      a: 'Responda as perguntas rápidas da página. No final, o WhatsApp abre com a sua mensagem pronta, é só enviar.',
    },
  ],

  finalCtaTitle: 'Pronto pra encontrar o seu imóvel?',
  finalCtaSubtitle: 'Leva menos de 2 minutos e é sem compromisso.',
  finalCtaButton: 'Encontrar meu imóvel',

  footerLabel: 'Sistema de atendimento imobiliário por NexoFácil',

  listingBadge: 'Disponível',
  listingCta: 'Quero saber mais',
  listingCtaHint: 'Leva 2 minutos · sem compromisso',
  listingNoPriceHint: 'Fale com a equipe pra receber valores e condições.',
  backToListings: 'Voltar aos imóveis',
};
